class bundleVariantButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {  
    this.disabledAddtoCartButton();
    
    this.addEventListener('change', (event) => {  
        this.selectedOptionValues();
        this.disabledAddtoCartButton();
    });
  }
            selectedOptionValues() {   
             let optionVall = '', optionList = [];  
              this.querySelectorAll('fieldset[data-position="1"] input:checked').forEach((inputVal) => {  
              if (inputVal) {
                var optionVall1 = inputVal.value; 
                }  
                this.querySelectorAll('fieldset[data-position="2"] input:checked').forEach((inputVal2) => {  
                  if (inputVal2) { 
                var optionVall2 = optionVall1+ '/' + inputVal2.value; 
                }
                  if (this.querySelectorAll('fieldset[data-position="3"]').length) {
                this.querySelectorAll('fieldset[data-position="3"] input').forEach((inputVal3) => {  
                  if (inputVal3) {  
                   optionVall = optionVall2+ '/' + inputVal3.value; 
                   }  this.bundleOptionValues(optionVall);
                  });
                  } else {
                    optionVall = optionVall2; 
                    this.bundleOptionValues(optionVall);
                  } 
            });  
            });  
     }
    bundleOptionValues(optionVall) {
      // console.log(optionVall);
    this.querySelectorAll('.bundleOption--inventory').forEach((button, index) => { 
     const dataVariant = button.getAttribute('data-variant'); 
     const dataOption = button.getAttribute('data-option'); 
     const dataInventory = parseInt(button.getAttribute('data-var-inventory'));   
     if (dataVariant == optionVall){   
      if (dataInventory <= 0) {  
         this.querySelector('.bundleOption--label[value="'+dataOption+'"]').classList.add('disabled'); 
        } else {
        // console.log(dataVariant);
        this.querySelector('.bundleOption--label[value="'+dataOption+'"]').classList.remove('disabled');
        }
     }  
    });
    }
      disabledAddtoCartButton() { 
      let inputChecked = false, allChecked, prod_id = [];
      document.querySelectorAll('bundle-variant-button').forEach((bundle) => {  
      const prodId = bundle.getAttribute('data-prod-id'); 
      let inputallValues = '',slashtag = '';
      bundle.querySelectorAll('fieldset').forEach((fieldset) => {   
      const radioGroups = [...new Set([...fieldset.querySelectorAll('input[type="radio"]')].map(radio => radio.name))]
       radioGroups.forEach(groupName => {
          const isChecked = document.querySelector(`input[name="${groupName}"]:checked`);
          if (!isChecked) {
              allChecked = false;  
          }
      }); 
        
        fieldset.querySelectorAll('input:checked').forEach((inputVal) => {   
          if (inputVal.classList.contains('disabled')) {
            allChecked = false;
          } 
           if (inputVal.value) { 
           inputallValues += slashtag + inputVal.value;
             slashtag = '/';
           }
        });  
     });  
      
       if (inputallValues){ 
        const element = document.querySelector('.bundleOption--inventory[data-variant="'+inputallValues+'"]'); 
        if (element && element.getAttribute('data-variant-id') !== null) {    
        document.querySelector('.prodVar_bundle-product[data-product-id="'+prodId+'"]').value = element.getAttribute('data-variant-id');
        document.querySelector('.prodVartitle_bundle-product[data-product-id="'+prodId+'"]').value = element.getAttribute('data-variant');
        this.querySelectorAll('.bundleOption--inventory').forEach((Option) => Option.classList.add('hidden'));
        element.classList.remove('hidden');  
        } 
       } 
        
       this.inputCheckedFunction(prodId, allChecked); 
        
   }); 
        
  }
        inputCheckedFunction(prodId, allChecked){   
          if (allChecked == false) {  
            document.querySelector('.product-form__submit').setAttribute('disabled', 'disabled'); 
            document.querySelector('.prod_bundleproduct[data-id="'+prodId+'"]').value = '';
            document.querySelector('.prodVar_bundle-product[data-product-id="'+prodId+'"]').value = ''; 
            document.querySelector('.prodVartitle_bundle-product[data-product-id="'+prodId+'"]').value = '';
            } else { 
            document.querySelector('.product-form__submit').removeAttribute('disabled');
            const value = document.querySelector('.prod_bundleproduct[data-id="'+prodId+'"]').getAttribute('data-value');
            // const variantId = document.querySelector('.prodVar_bundle-product[data-product-id="'+prodId+'"]');
             if (value) { 
               console.log(prodId);
              document.querySelector('.prod_bundleproduct[data-id="'+prodId+'"]').value = value; 
              // document.querySelector('.prodVar_bundle-product[data-product-id="'+prodId+'"]').value = variantId.getAttribute('data-var-id');
             } 
          }
        }  
  
}
  customElements.define('bundle-variant-button', bundleVariantButton);